<template>
  <div style="width: 100%">
    <v-col cols="12">
      <app-title texto="RESULTADOS" />
    </v-col>
    <v-col>
      <v-card
        flat
        outlined
        class="pa-2"
      >
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="perfis"
            item-key="siape"
            :items-per-page="10"
            :search="opcoes.pesquisa"
            :sort-by="opcoes.ordenarPor"
            :sort-desc="opcoes.decrescente"
            class="elevation-0"
            no-data-text="Nenhum perfil encontrado para o(s) filtro(s) escolhido(s)."
          >
            <template v-slot:[`item.numero`]="{ index }">
              {{ index + 1 }}
            </template>

            <template v-slot:[`item.perfil`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-2"
                    icon
                    small
                    color="secondary"
                    v-on="on"
                    @click="openDialogPerfil(item)"
                  >
                    <v-icon>perm_contact_calendar</v-icon>
                  </v-btn>
                </template>
                <span>Clique para visualizar o perfil</span>
              </v-tooltip>
            </template>

            <template v-slot:top>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <app-sort v-model="opcoes" />
                </v-col>
                <v-col
                  cols="0"
                  md="4"
                />
                <v-col
                  cols="12"
                  md="4"
                >
                  <app-search v-model="opcoes" />
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <dialog-perfil :dialog-props="dialogPerfilProps" />
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import DialogPerfil from '@/components/perfil/DialogPerfil';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'ResultadoFiltroBusca',

  components: {
    AppTitle,
    DialogPerfil,
    AppSort,
    AppSearch,
  },

  props: {
    perfis: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Nº',
          value: 'numero',
          sortable: false,
          align: 'center',
        },
        { text: 'SERVIDOR', value: 'nome', sortable: false },
        {
          text: 'SIAPE',
          value: 'siape',
          sortable: false,
          width: '15%',
          align: 'center',
        },
        {
          text: 'UNIDADE',
          value: 'unidadeSigla',
          sortable: false,
          width: '15%',
          align: 'center',
        },
        {
          text: 'CARGO',
          value: 'cargo',
          sortable: false,
          align: 'center',
        },
        {
          text: 'CATEGORIA',
          value: 'categoria',
          sortable: false,
          align: 'center',
        },
        {
          text: 'PERFIL',
          value: 'perfil',
          sortable: false,
          width: '10%',
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nome',
        selecionado: { id: 'nome', descricao: 'Nome do Servidor' },
        lista: [
          { id: 'nome', descricao: 'Nome do Servidor' },
          { id: 'siape', descricao: 'SIAPE' },
          { id: 'unidadeSigla', descricao: 'Unidade' },
          { id: 'cargo', descricao: 'Cargo' },
          { id: 'categoria', descricao: 'Categoria' },
        ],
      },
      dialogPerfilProps: {
        titulo: 'Perfil do Servidor',
        usuarioId: null,
        load: false,
        visibilidade: false,
      },
    };
  },

  methods: {
    openDialogPerfil(item) {
      this.dialogPerfilProps.perfilId = item.id;
      this.dialogPerfilProps.load = true;
    },
  },
};
</script>
